import { FC } from 'react';
import { CreateDataSourceContent } from './createDataSourceContent';
import { useParams } from 'react-router-dom';
import { DataSource, DataSourceIDEnum } from '@/models/dataSource';
import { PageLayout } from '@/global/components';
import { BreadcrumbItem, Breadcrumbs } from '@/lib/Breadcrumbs';
import RouteConstants from '@/features/router/RouteConstants';
import { IModalContentProps } from '@/models/modals';
import { ModalHeader } from '@/components/modals';
import { useTranslation } from 'react-i18next';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'data_sources:title',
    path: RouteConstants.dataSources,
  },
  {
    label: 'data_sources:tabs.catalog.title',
    path: RouteConstants.dataSources,
  },
];

type CreateDataSourcePros = {
  dataSourceId: DataSourceIDEnum;
  onSuccess: (dataSource: DataSource) => void;
  onSuccessAndContinue?: (dataSource: DataSource) => void;
  requiredMapping?: { traitIds: Array<string | number>; tooltip: string };
  autoAudienceTraitId?: string;
} & IModalContentProps;

export const CreateDataSource: FC<CreateDataSourcePros> = ({
  dataSourceId,
  onSuccess,
  onSuccessAndContinue,
  requiredMapping,
  autoAudienceTraitId,
  closeModal,
}) => {
  const { t } = useTranslation('data_sources');
  const id = dataSourceId || useParams<{ id: DataSourceIDEnum }>().id;

  const isModal = !!closeModal;
  const handleOnSuccess = (dataSource: DataSource) => {
    onSuccess(dataSource);
    closeModal();
  };

  console.log('CreateDataSource', id);

  return isModal ? (
    <>
      <ModalHeader classNames={{ wrapper: 'border-b pb-4 py-4' }} title={t(`catalog.${dataSourceId}.title`)} closeModal={closeModal} />
      <PageLayout>
        <CreateDataSourceContent
          dataSourceId={id}
          requiredMapping={requiredMapping}
          autoAudienceTraitId={autoAudienceTraitId}
          modalProps={{
            onSuccess: handleOnSuccess,
            onSuccessAndContinue,
            closeModal,
          }}
        />
      </PageLayout>
    </>
  ) : (
    <PageLayout>
      <header className='grid gap-4'>
        <Breadcrumbs className='border-b pb-4' items={breadcrumbs} />
      </header>
      <CreateDataSourceContent dataSourceId={id} />
    </PageLayout>
  );
};
